import {useState} from 'react';

import type {GetArticleResponse} from '@dms/api/warehouse';

import {generateHashFromObjects} from 'shared/web';

import {getArticleSellingPriceWarning} from '../utils/getArticleSellingPriceWarning';

export function useArticleSellingPriceWarning(article: GetArticleResponse | undefined) {
  const articleRevision = generateHashFromObjects(article ?? {});
  const [draftPriceWarning, setDraftPriceWarning] = useState<{
    articleRevision: string;
    message: ReturnType<typeof getArticleSellingPriceWarning>;
  }>();

  const sellingPriceWarning =
    draftPriceWarning?.articleRevision === articleRevision
      ? draftPriceWarning.message
      : getArticleSellingPriceWarning(
          article?.dispensingPrices.saleBasePriceWithoutVat,
          article?.pricesSettings.avgPurchasePriceWithoutVat,
          article?.pricesSettings.lastPurchasePriceWithoutVat
        );

  const handleSellingPriceWarningChange = (
    message: ReturnType<typeof getArticleSellingPriceWarning>
  ) => {
    setDraftPriceWarning((previous) =>
      previous?.articleRevision === articleRevision && previous.message === message
        ? previous
        : {articleRevision, message}
    );
  };

  return {articleRevision, sellingPriceWarning, handleSellingPriceWarningChange};
}
